export default "__VITE_ASSET__BahkrTH7__"